import { render, staticRenderFns } from "./StageColumn.vue?vue&type=template&id=19102d06"
import script from "./StageColumn.vue?vue&type=script&lang=js"
export * from "./StageColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports